/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint max-lines: ["error", 600]*/
/* eslint-disable no-lonely-if */
import countriesOptions from '@/mixins/countriesOptions';
import DatePickerMixin from '@/mixins/datepicker';
import formatData from '@/mixins/formatData';
import DraftData from '@/components/draft-data';
import indicatorsFatcaOptions from '@/mixins/fatca/indicatorsFatcaOptions';
import keyed from '@/mixins/keyed';
import statusFatcaOptions from '@/mixins/fatca/statusFatcaOptions';
import tinTypesOptions from '@/mixins/fatca/tinTypesOptions';
import Validations from '@/mixins/validations';


export default {

    /**
     * Nombre del componente
     */
    name: 'FatcaData',

    components: {
        DraftData
    },

    mixins: [
        countriesOptions,
        formatData,
        keyed,
        Validations,
        indicatorsFatcaOptions,
        statusFatcaOptions,
        tinTypesOptions,
        DatePickerMixin
    ],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            collapsed: true,
            vissibilityCollapse1: true,
            fatcaDataEdit: false,
            hasFatcaData: false,
            datepickerExpiration: ''
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        data: {
            type: Object,
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerType: {
            type: String,
            required: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        data: {
            immediate: true,
            /**
             * Update formattedData when data changes
             */
            handler() {
                this.formatData();
                this.modifiedData = {};
            }
        },
        datepickerExpiration(val) {
            this.setValueEdited('tin_expiration_date', val);
        }
    },
    methods: {

        /**
         * @return {String} field to show/edit as FATCA code
         */
        fatcaCodeField() {
            if (this.intervenerType !== 'J') return 'tin_code';
            if (this.formattedData.tin_code) return 'tin_code';
            return 'giin_code';
        },

        /**
         * @return {Boolean} true when FATCA code field is GIIN
         */
        showGiinCodeField() {
            return this.fatcaCodeField() === 'giin_code';
        },

        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        editFatcaData(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.fatcaDataEdit = edit;
            if (edit) {
                if (!this.collapsed) {
                    this.$root.$emit('bv::toggle::collapse', 'collapse-1');
                }
            }
            if (!edit) {
                this.formatData();
                this.modifiedData = {};
            }
        },
        
        /**
         * Validate FATCA data
         * @return {Boolean} valid or not
         */
        validateData() {
            this.cleanErrors();

            const requiredProperties = [this.fatcaCodeField()];

            return Promise.resolve(true)
                .then(valid => this.validateRequired(requiredProperties, valid));
        },
        // /**
        //  * Validate FATCA data
        //  * @return {Boolean} valid or not
        //  */
        // validateData() {
        //     this.cleanErrors();

        //     const requiredProperties = [
        //         this.intervenerType === 'J' ? 'giin_code' : 'tin_code',
        //         'legal_entity_type'
        //     ];
        //     if (this.modifiedData && this.modifiedData.legal_entity_type === 'ENTIDAD_NO_CLASIFICADA'
        //         || this.data && this.data.legal_entity_type === 'ENTIDAD_NO_CLASIFICADA') {
        //         requiredProperties.push('custom_legal_entity_type');
        //     }

        //     return Promise.resolve(true)
        //         .then(valid => this.validateRequired(requiredProperties, valid));
        // },
        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            this.modifiedData[field] = (typeof val === 'object' && val !== null) ? val.key : val;
        },

        // TODO: Se tendría que validar el giin también?
        validateTinNumber() {
            return this.$intervenersService.validateTinNumber(
                this.modifiedData.tin_code
            );
        },

        /**
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            e.preventDefault();

            const promises = [this.fetchValidatedData()];
            // TODO: El cliente aún no ha especificado si quiere que el tin de fatca se valide
            // de ser así haría falta un selector de país
            Promise.all([promises])
                .then(responses => {
                    if (!responses[0]) {
                        this.$toast.error('Error en datos de fatca', 'Revisa los campos marcados en rojo');
                        return;
                    }
                    Promise.all([
                        this.$intervenersService.updateIntervenerFATCA(this.uuid, this.modifiedData)
                    ])
                        .then(res => {
                            this.$emit('saved', res[0].data.intervener_fatca);
                            this.$root.$emit('refresh_intervener');
                            this.fatcaDataEdit = false;
                            this.modifiedData = {};
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        })
                        .catch(err => {
                            this.$toast.error(err.name, err.message);
                            this.formatData();
                            this.fatcaDataEdit = false;
                            this.modifiedData = {};
                        });
                });
        },
    },

    /**
     * @override
     */
    beforeMount() {
        if (this.creation) {
            this.fatcaDataEdit = !this.existing;
        }
    }
};
